import React from 'react';

import {
  styled,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@gogame/components';

import {
  DYNAMIC,
  CONDITION_TYPE,
  METRIC,
  OPERATOR,
  CALCULATION_TYPE,
  VALUE,
  WEIGHTED_AVERAGE,
  PERCENTILE,
} from 'scenes/SmartRules/SmartRuleForm/Conditions';
import { useFormatValue, PERCENT } from 'scenes/SmartRules/hooks';

const Container = styled(TableContainer)`
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 5px;

  ${'tbody>tr:last-child>td'} {
    border-bottom: 0;
  }
`;

export const Conditions = ({ conditions }) => {
  const formatValue = useFormatValue();

  return (
    <Container>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Metric</TableCell>
            <TableCell>Operator</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {conditions.map(
            (
              {
                [CONDITION_TYPE]: type,
                [METRIC]: metric,
                [OPERATOR]: operator,
                [CALCULATION_TYPE]: calculationType,
                [VALUE]: value,
              },
              i
            ) => {
              const dynamic = type === DYNAMIC;
              const weightedAverage = calculationType === WEIGHTED_AVERAGE;
              const percentile = calculationType === PERCENTILE;
              return (
                <TableRow key={i}>
                  <TableCell>{type}</TableCell>
                  <TableCell>{metric}</TableCell>
                  <TableCell>{operator}</TableCell>
                  <TableCell style={{ wordBreak: 'break-all' }}>
                    {dynamic && weightedAverage
                      ? 'weighted average'
                      : formatValue(
                          value,
                          dynamic && percentile ? PERCENT : type,
                          type
                        )}
                  </TableCell>
                </TableRow>
              );
            }
          )}
        </TableBody>
      </Table>
    </Container>
  );
};
